import $ from 'jquery';

// Dropdown filter
export default class CheckboxDropdown {

  constructor($element, options) {

    if ($element.length === 0) return false;

    this.$element = $element;

    $.messages.on('FILTER/VALUE_CHANGED', (action) => {
      if(action.sender.$element.get(0) === this.$element.find('[data-wjp-filter]').get(0) ) {
        if (action.sender.getValue()) {
          this.$element.addClass('active');
        } else {
          this.$element.removeClass('active');
        }
      }
    });
  }

}



/** WEBPACK FOOTER **
 ** ../assets/js/components/CheckboxDropdown.js
 **/